import styled from '@emotion/styled';

export const HeaderWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: inherit;
`;

export const Label = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: inherit;
`;
